// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"dd646e05","819":"cc27798f","833":"88486160"}[chunkId] + ".chunk.css";
};